import PropTypes from 'prop-types'
import React from 'react'
import cn from 'classnames'
import Option from './option'
import SelectLocationContainer from '../../containers/calendar/select-location-container'
import SelectAreaContainer from '../../containers/calendar/select-area-container'
import SelectTechnicianContainer from '../../containers/calendar/select-technician-container'
import SelectServiceContainer from '../../containers/calendar/select-service-container'
import LoaderContainer from '../../containers/loader/loader-container'

class Toolbar extends React.Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    messages: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    onViewChange: PropTypes.func.isRequired,
  }

  render() {
    const {
      messages,
      label,
      date,
      locationId,
      areaId,
      technicianId,
      serviceIds,
    } = this.props

    const year = date.getFullYear(), month = date.getMonth()

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, 'TODAY')}
          >
            {messages.today}
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, 'PREV')}
          >
            {messages.previous}
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, 'NEXT')}
          >
            {messages.next}
          </button>
        </span>

        <span className="rbc-toolbar-label">
          {label}
          <LoaderContainer resource={`calendarFilters.${year}.${month}`} />
        </span>

        <span style={{display: 'inline-flex'}} onClick={(e) => e.preventDefault()} className='maats-calendar-toolbar-filters'>
          <SelectLocationContainer
            className="maats-calendar-toolbar-select"
            placeholder="Locations..."
            value={locationId}
            onChange={(item) => {
              const value = item ? item.value : null
              this.setState({locationId: value})
            }}
            optionComponent={Option}
          />
          <SelectServiceContainer
            className="maats-calendar-toolbar-select"
            placeholder="Service..."
            locationId={locationId}
            disabled={!locationId}
            value={serviceIds}
            onChange={(items) => {
              const serviceIds = items ? items.map(item => (item.value)) : null
              this.setState({ serviceIds })
            }}
            optionComponent={Option}
          />
          <SelectAreaContainer
            className="maats-calendar-toolbar-select"
            placeholder="Areas..."
            locationId={locationId}
            value={areaId}
            disabled={!locationId}
            optionComponent={Option}
            onChange={(item) => {
              const value = item ? item.value : null
              this.setState({areaId: value})
            }}
          />
          <SelectTechnicianContainer
            className="maats-calendar-toolbar-select"
            placeholder="Technicians..."
            locationId={locationId}
            areaId={areaId}
            value={technicianId}
            optionComponent={Option}
            onChange={(item) => {
              const value = item ? item.value : null
              this.setState({technicianId: value})
            }}
          />
        </span>

        <span className="rbc-btn-group">{this.viewNamesGroup(messages)}</span>
      </div>
    )
  }

  navigate = (action) => {
    this.props.onNavigate(action)
  }

  view = (view) => {
    this.props.onViewChange(view)
  }

  viewNamesGroup(messages) {
    let viewNames = this.props.views
    const view = this.props.view

    if (viewNames.length > 1) {
      return viewNames.map((name) => (
        <button
          type="button"
          key={name}
          className={cn({ 'rbc-active': view === name })}
          onClick={this.view.bind(null, name)}
        >
          {messages[name]}
        </button>
      ))
    }
  }
}

export default Toolbar



// WEBPACK FOOTER //
// ./src/components/calendar/toolbar.js